const topics = [
  { label: '明星出轨合集', count: 1286, hot: true },
  { label: '合约纠纷黑料', count: 943, hot: true },
  { label: '私生活大揭秘', count: 2156, hot: true },
  { label: '综艺翻车现场', count: 567, hot: false },
  { label: '饭圈互撕实录', count: 1834, hot: true },
  { label: '资本操控内幕', count: 421, hot: false },
  { label: '选秀黑幕曝光', count: 789, hot: true },
  { label: '跨界丑闻汇总', count: 654, hot: false },
];

export default function Index() {
  return (
    <section id="index" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            瓜料合集
          </h2>
          <p className="text-foreground-500 text-sm">热门八卦专题 · 一站式浏览</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 md:gap-4">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className="group relative bg-background-50 border border-background-200/70 rounded-xl p-4 md:p-5 hover:border-primary-300 hover:shadow-sm transition-all duration-200 cursor-pointer"
            >
              {item.hot && (
                <span className="absolute -top-1.5 -right-1.5 px-2 py-0.5 bg-accent-500 text-white text-[10px] font-bold rounded-full whitespace-nowrap">
                  HOT
                </span>
              )}
              <div className="flex flex-col items-center text-center gap-2">
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700 group-hover:bg-primary-100 group-hover:text-primary-600 transition-colors">
                  <i className="ri-folder-3-line text-lg"></i>
                </div>
                <span className="text-sm font-medium text-foreground-800 whitespace-nowrap">
                  {item.label}
                </span>
                <span className="text-xs text-foreground-400">{item.count} 条瓜料</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}